define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    function parseQuery(text) {
        if (text && text.length > 1 && text[0] === '?') {
            text = text.substr(1);
            var pairs = text.split('&');
            var nvs = $.map(pairs, function (nv) {
                var exp = nv.split(/=([^&]*)/, 2);
                return [[exp[0], decodeURIComponent(exp[1])]];
            });
            var result_1 = {};
            $.each(nvs, function (name, val) { result_1[val[0]] = val[1]; });
            return result_1;
        }
        return {};
    }
    exports.parseQuery = parseQuery;
    function formatQuery(query) {
        var sb = [];
        $.each(query, function (name, value) {
            sb.push(name + "=" + encodeURIComponent(value));
        });
        if (sb.length) {
            return "?" + sb.join('&');
        }
        return '';
    }
    exports.formatQuery = formatQuery;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/querystring.js
// module id = 6
// module chunks = 0